import { useAppSelector } from '@/hooks/redux';
import { selectNotificationsListReversed } from '@/store/selectors';
import { TNotification } from '@/types/notifications';

export const useNotifications = (): {notifications: TNotification[]} => {
    const notifications = useAppSelector(selectNotificationsListReversed);

    return {notifications};
};
